import { render, staticRenderFns } from "./StationInfo.vue?vue&type=template&id=0fd4b198&"
import script from "./StationInfo.vue?vue&type=script&lang=ts&"
export * from "./StationInfo.vue?vue&type=script&lang=ts&"
import style0 from "./StationInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports